import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { NotificationContainer } from './components/global_noification_component';
import NavigationProvider from './components/global_navbar_component';
import LandingPage from './pages/landing_page';
import DocumentationPage from './pages/documentation_page';
import DiscordAuthPage from './pages/discord_authentication_page';
import ApplicationsPage from './pages/applications_page';
import ApplicationContentCreatorPage from './pages/discord_content_creator_application_page';
import ApplicationTrueBallerPage from './pages/discord_true_baller_application_page';
import ItemsPage from './pages/items_page';
import DashboardPage from "./pages/dashboard_page";

const REACT_APP_API_DISCORD_OAUTH_PAGE=process.env.REACT_APP_API_DISCORD_OAUTH_PAGE;
function AuthErrorInterceptor() {
  const navigate = useNavigate();

  useEffect(() => {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const res = await originalFetch(...args);
      try {
        const clone = res.clone();
        const text = await clone.text();
        let grantError = false;
        if (text.includes('invalid_grant')) {
          grantError = true;
        } else {
          try {
            const json = JSON.parse(text);
            if (typeof json.error === 'string' && json.error.includes('invalid_grant')) {
              grantError = true;
            }
          } catch (_) {
          }
        }
        if (grantError) {
          [
            'code',
            'refresh_token',
            'discord_id',
            'username',
            'global_name',
            'avatar',
            'banner',
            'email',
            'cc_application_locked_until'
          ].forEach(c => Cookies.remove(c));
          navigate(`${REACT_APP_API_DISCORD_OAUTH_PAGE}`);
        }
      } catch (_) {} return res;
    };
    return () => {
      window.fetch = originalFetch;
    };
  }, [navigate]);

  return null;
}

export default function App() {
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);

  return (
    <BrowserRouter>
      <div className="App">
        <NotificationContainer />
        <div className="blob blob1" />
        <div className="blob blob2" />
        {isNavbarVisible && <NavigationProvider />}
        <AuthErrorInterceptor />
        <main className="main-content">
          <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/documentation" element={<DocumentationPage />} />
              <Route path="/discord-link" element={<DiscordAuthPage />} />
              <Route path="/apply" element={<ApplicationsPage />} />
              <Route path="/apply/content-creator" element={<ApplicationContentCreatorPage />} />
              <Route path="/apply/true-baller" element={<ApplicationTrueBallerPage />} />
              <Route path="/items" element={<ItemsPage />} />
              <Route path="/dashboard" element={<DashboardPage setNavbarVisible={setIsNavbarVisible} />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
  );
}